var _excluded = ["hide"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import { ScreenReaderOnly } from "@xo-union/ui-accessibility";
import { DESKTOP, MOBILE } from "../../utils/index.js";
import styles from "./styles.css";
var getEllipsesClassName = function getEllipsesClassName(hide) {
  switch (hide) {
    case DESKTOP:
      return styles.ellipsesHiddenInDesktop;
    case MOBILE:
      return styles.ellipsesHiddenInMobile;
    default:
      return '';
  }
};
var Ellipses = function Ellipses(_ref) {
  var hide = _ref.hide,
    rest = _objectWithoutProperties(_ref, _excluded);
  var className = getEllipsesClassName(hide);
  return /*#__PURE__*/React.createElement("li", _extends({
    className: className
  }, rest), /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true"
  }, "..."), /*#__PURE__*/React.createElement(ScreenReaderOnly, null, "Additional page links hidden"));
};
process.env.NODE_ENV !== "production" ? Ellipses.propTypes = {
  hide: PropTypes.oneOf([DESKTOP, MOBILE])
} : void 0;
Ellipses.defaultProps = {
  hide: undefined
};
export default Ellipses;